import axios, {AxiosResponse} from 'axios';
import Vue from 'vue';
import AxiosConfig from '@/request/config';
import {CourseApi} from './api/course';

enum ResponseCode {
  '请求失败' = 0,
}

export const interceptorTactics = {
  /**http协议响应错误处理*/
  async responseHttpCodeError(response: AxiosResponse): Promise<AxiosResponse> {
    if (response.status === 200) {  //请求成功
      return Promise.resolve(response);
    }
    if (response.status === 500) {  //500错误捕获
      return Promise.reject(response.data.msg ?? response.data.message);
    }
    if (response.status === 401) {   //权限缺失
    }
    return Promise.reject(response.data.message);
  },
  /**业务错误*/
  async responseServiceCodeError(response: AxiosResponse): Promise<AxiosResponse> {
    let code: ResponseCode = response.data?.status;
    return Promise.resolve(response);
  },
};

const config = AxiosConfig;

export function CikeAxios() {
  axios.defaults.baseURL = config.baseURL;
  axios.interceptors.request.use(config => {
    // 在发送请求之前做些什么
    return config;
  }, error => {
    // 请求错误做些什么
    Vue.prototype.$message.error(error.msg);
  });
  axios.interceptors.response.use(config => {
    return interceptorTactics.responseServiceCodeError(config)
      .then(response => interceptorTactics.responseHttpCodeError(response))
      .then(response => {
        return Promise.resolve(response.data?.new_response ? response.data.data : response.data);
      })
      .catch((err) => { //错误处理

      });
  });
  return axios;
}


/**此刻apis*/
export default class CikeApi {
  private course = new CourseApi();
}
